import type { JSONContent } from '@tiptap/core'
import { TmFontFamilies } from '@/services/forms/tmTiptap/extensions/types'
import { gray300 } from '@/styles/variables.module.scss'

export const tmRichEditorCodeBlockClass = 'tm-editor-code-block'

export const tagNodeName = 'tag' as const
export const tagAttributeValue = 'data-tag' as const
export const tagClass = 'editor-tag' as const
export const tagClassError = `${tagClass}--error` as const

export const getTagWithSpecialChars = (tag: string) => `{${tag}}`

export const enum EditorSystemTags {
  UNSUBSCRIBE_LINK = 'Unsubscribe link',
  DEFAULT_FOOTER = 'Default footer',
}

export const EditorSystemTagsWithSpecialChars = {
  UNSUBSCRIBE_LINK: getTagWithSpecialChars(EditorSystemTags.UNSUBSCRIBE_LINK),
  DEFAULT_FOOTER: getTagWithSpecialChars(EditorSystemTags.DEFAULT_FOOTER),
} as const

export const initialSetupMetaKey = 'initialSetup' as const

export const linkMarkName = 'customLink' as const
export const linkClass = 'editor-link' as const

export const emojiTagName = 'IMG' as const
export const emojiAttributeName = 'emoji' as const
export const EMOJI_TEXT_ATTRIBUTE = 'data-text' as const
export const EMOJI_COLONS_ATTRIBUTE = 'data-emoji-colons' as const
export const HTML_DATA_ATTRIBUTE = 'data-type' as const

export const htmlTagNotOfDataTypes = (tag: string, notOfDataType: string[]) => {
  return tag + notOfDataType.map((type) => `:not([${HTML_DATA_ATTRIBUTE}="${type}"])`).join('')
}

export const getWysiwygEmailEditorDefaultContent = (bodyContent = '<p></p>') => `
<!DOCTYPE html>
<html>
  <head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
    <style>
      body {
        margin: 0;
        padding: 10px 20px;
      }
      p, li {
        margin-top: 0;
        margin-bottom: 0.5em;
        font-size: 14px;
      }
      p,h1,h2,h3,h4,h5,h6,li {
        font-family: ${TmFontFamilies.ARIAL};
      }
      table {
        border-collapse: collapse;
        margin-bottom: 1rem;
        table-layout: fixed;
      }
      table, th, td {
        border: solid 1px ${gray300};
      }
      th, td {
        padding: 8px;
        word-break: break-word;
      }
    </style>
  </head>
  <body>
    ${bodyContent}
  </body>
</html>
`
export const emptyEditorValue: JSONContent = {
  type: 'doc',
  content: [{ type: 'paragraph' }],
} as const
